{
  "nl": {
    "upload": {
      "labels": {
        "cancelUpload": "Annuleren",
        "cancelUploadConfirmation": "Weet je zeker dat je deze upload wilt annuleren?",
        "chooseCategory": "Klik om eerst een categorie te selecteren",
        "defaultMessage": "Bestanden toevoegen of neerzetten",
        "fallbackMessage": "Uw browser ondersteunt het uploaden van bestanden via drag'n'drop niet.",
        "fallbackText": "Gebruik het onderstaande formulier om je bestanden te uploaden zoals vroeger.",
        "fileTooBig": "Bestand is te groot ({filesize} MB). Maximale bestandsgrootte: {maxFilesize} MB.",
        "invalidFileType": "Je kunt geen bestanden van dit type uploaden.",
        "maxFilesExceeded": "U kunt geen bestanden meer uploaden.",
        "noExtension": "Bestand heeft geen extensie",
        "rejectedFiles": "De volgende bestanden zijn afgekeurd:",
        "removeFile": "Bestand verwijderen",
        "responseError": "De server reageerde met {statusCode} code.",
        "uploadConfirmation": "Upload Bevestigd",
        "uploadError": "Fout bij uploaden",
        "warningMaxFileSize": "Tot {max_files_size} elk"
      }
    }
  }
}